import { Center, Loader } from "@mantine/core";
import { formatNZD, parseNumberOrNull } from "common/utils";

import { safeApiCall } from "api/common.service";
import { getCurrentPrices } from "api/report.service";
import { MAX_PAGE_SIZE } from "common/constants";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { RptCurrentPrices } from "types/model.types";

const ProductPriceListPreview: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<RptCurrentPrices>([]);

  const [params] = useSearchParams();
  const rptType = params.get("rpt");
  const reportType = rptType ? Number(rptType ?? 0) : 0;
  const fromCode = params.get("f") ?? "";
  const toCode = params.get("t") ?? "";

  useEffect(() => {
    let mounted = true;

    const fetchData = async () => {
      try {
        const from: number | null = parseNumberOrNull(fromCode);
        const to: number | null = parseNumberOrNull(toCode);

        const result = await safeApiCall(
          getCurrentPrices(from, to, MAX_PAGE_SIZE, 1),
        );
        if (mounted && result) setData(result?.data ?? []);
      } finally {
        setLoading(false);
      }
    };

    setLoading(true);
    fetchData();

    return () => {
      mounted = false;
    };
  }, []);

  if (loading) {
    return (
      <Center style={{ height: "100vh" }}>
        <Loader size="lg" />
      </Center>
    );
  }

  return (
    <>
      <div className="sub-title">Price List</div>
      <table className="details-table">
        <thead>
          <tr>
            <th>Product</th>
            <th className={`description ${reportType === 0 ? "xs" : "xs-1"}`}>
              Description
            </th>
            <th>Carton Price</th>
            {reportType !== 0 ? (
              <th>Each Price</th>
            ) : (
              <>
                <th>Retail</th>
                <th>SP1</th>
                <th>SP2</th>
                <th>SP3</th>
                <th>SP4</th>
              </>
            )}
            <th>Measure</th>
            <th>Barcode</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((row, index) => (
              <tr key={`${index}-${row.id}`}>
                <td>{row.id}</td>
                <td
                  className={`description ${reportType === 0 ? "xs" : "xs-1"}`}
                  style={{
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {row.description}
                </td>
                {/* 0: All, 1: Retail, 2: SP1, 3: SP2 */}
                {reportType === 1 ? (
                  <td>{formatNZD(row.retailCtnPrice)}</td>
                ) : reportType === 3 ? (
                  <td>{formatNZD(row.sellPrice2CtnPrice)}</td>
                ) : (
                  <td>{formatNZD(row.sellPrice1CtnPrice)}</td>
                )}
                {reportType !== 0 ? (
                  reportType === 1 ? (
                    <td>{formatNZD(row.retail)}</td>
                  ) : reportType === 3 ? (
                    <td>{formatNZD(row.sellPrice2)}</td>
                  ) : (
                    <td>{formatNZD(row.sellPrice1)}</td>
                  )
                ) : (
                  <>
                    <td>{formatNZD(row.retail)}</td>
                    <td>{formatNZD(row.sellPrice1)}</td>
                    <td>{formatNZD(row.sellPrice2)}</td>
                    <td>{formatNZD(row.sellPrice3)}</td>
                    <td>{formatNZD(row.sellPrice4)}</td>
                  </>
                )}
                <td>{`${row.unitsCtn} CTN`}</td>
                <td>{row.barcode}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </>
  );
};

export default ProductPriceListPreview;
